/* Bridges the draft's buy box to real Shopify variants.
   The design keeps its own size buttons; this only makes them mean something:
   the initial selection, the sticky bar's product name, and a real add to cart.
   Loaded after elevana-product-*.js so the globals it patches already exist. */
(function () {
  var P = window.EL_PDP;
  if (!P || !P.variants || !P.variants.length) return;

  var sizes = document.getElementById('sizes');
  var first = sizes && sizes.querySelector('.sz.on');
  if (first && typeof window.pickSize === 'function') window.pickSize(first);

  function selectedVariant() {
    var on = sizes && sizes.querySelector('.sz.on');
    if (on && on.dataset.id) {                 /* exact variant: bulk sizes can't be told apart by grams alone */
      for (var j = 0; j < P.variants.length; j++) if (String(P.variants[j].id) === on.dataset.id) return P.variants[j];
    }
    var g = on ? parseFloat(on.dataset.g) : null;
    for (var i = 0; i < P.variants.length; i++) {
      if (g !== null && Math.abs(P.variants[i].g - g) < 0.001) return P.variants[i];
    }
    return P.variants[0];
  }

  function qty() {
    var q = document.getElementById('qty');
    return Math.max(1, parseInt(q && q.textContent, 10) || 1);
  }

  function add(btn) {
    var v = selectedVariant();
    if (!v || !v.available) { flash(btn, 'Sold out'); return; }
    btn.dataset.busy = '1';
    if (window.ElevanaCart) {                 /* opens the bag; see elevana-cart.js */
      window.ElevanaCart.add([{ id: v.id, quantity: qty() }])
        .catch(function () {})
        .finally(function () { delete btn.dataset.busy; });
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        bumpCartCount(qty());
        flash(btn, '✓ Added to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { flash(btn, 'Could not add — try again'); });
  }

  function flash(btn, label) {
    var html = btn.innerHTML;
    btn.classList.add('added');
    btn.innerHTML = label;
    setTimeout(function () {
      btn.classList.remove('added');
      btn.innerHTML = html;
      delete btn.dataset.busy;
    }, 1600);
  }

  function bumpCartCount(n) {
    var c = document.querySelector('.cart-n');
    if (c) c.textContent = (parseInt(c.textContent, 10) || 0) + n;
  }

  ['addBtn', 'sbBtn'].forEach(function (id) {
    var btn = document.getElementById(id);
    if (!btn) return;
    var clone = btn.cloneNode(true);          // drop the draft's fake handler
    btn.parentNode.replaceChild(clone, btn);
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      if (!this.dataset.busy) add(this);
    });
  });

  /* the draft hardcoded one strain name into the sticky bar */
  if (P.title) {
    var render = window.render;
    if (typeof render === 'function') {
      window.render = function () {
        render.apply(this, arguments);
        var sm = document.getElementById('sbMeta');
        if (sm) sm.innerHTML = sm.innerHTML.replace(/<b>[^<]*<\/b>/, '<b>' + P.title + '<\/b>');
      };
      window.render();
    }
  }
})();

/* "See it before you buy it": the clips play by themselves while the section is on
   screen and pause when it scrolls away. Muted + playsinline is what browsers require
   for autoplay; preload stays "none", so nothing downloads until the section is in
   view. Tapping still pauses/plays, and a clip the shopper paused stays paused. */
(function () {
  var cards = [].slice.call(document.querySelectorAll('.vcard'));
  if (!cards.length) return;

  cards.forEach(function (card) {
    var v = card.querySelector('video'), pp = card.querySelector('.pp');
    if (!v) return;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    function icon() { if (pp) pp.innerHTML = v.paused ? '&#9658;' : '&#10074;&#10074;'; }
    v.addEventListener('play', icon);
    v.addEventListener('pause', icon);
    /* runs after the inline togVid() handler, so v.paused is the new state */
    card.addEventListener('click', function () { card.dataset.held = v.paused ? '1' : ''; });
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (!v) return;
      if (e.isIntersecting && !e.target.dataset.held) v.play().catch(function () {});
      else if (!e.isIntersecting) v.pause();
    });
  }, { threshold: 0.35 });
  cards.forEach(function (c) { io.observe(c); });
})();

/* "Build your bundle": the draft only bumped the badge. Add the real bags instead.
   Flower: each strain's bundle price is its 28 g price, so pick the variant at that price.
   Concentrates: each entry names the size to add (s.cart = "1 g"), so pick that size. */
(function () {
  var btn = document.getElementById('bundleBtn');
  if (!btn || !window.STRAINS || typeof window.countItems !== 'function') return;
  var clone = btn.cloneNode(true);
  btn.parentNode.replaceChild(clone, btn);
  function slug(n) { return n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  clone.addEventListener('click', function (e) {
    e.preventDefault();
    if (this.dataset.busy || !window.countItems()) return;
    var self = this, picks = window.STRAINS.filter(function (s) { return (window.picked || {})[s.id] > 0; });
    self.dataset.busy = '1';
    Promise.all(picks.map(function (s) {
      if (s.vid) return { id: s.vid, quantity: window.picked[s.id] }; /* pre-rolls: the live variant is already known */
      return fetch((window.PU ? window.PU(slug(s.name)) : '/products/' + slug(s.name)) + '.js')
        .then(function (r) { if (!r.ok) throw new Error(s.name); return r.json(); })
        .then(function (p) {
          var cents = Math.round(s.price * 100), v = null;
          /* concentrates name their bundle size ("1 g"): take the first in-stock variant of that size */
          if (s.cart) p.variants.forEach(function (x) { if (x.available && String(x.title).toLowerCase().split(' / ').pop() === String(s.cart).toLowerCase()) v = v || x; });
          if (!v && !s.cart) p.variants.forEach(function (x) { if (x.available && x.price === cents) v = v || x; });
          if (!v && s.cart) throw new Error(s.name + ' ' + s.cart + ' is sold out');
          if (!v) p.variants.forEach(function (x) { if (x.available && (!v || x.price > v.price)) v = x; });
          if (!v) throw new Error(s.name + ' is sold out');
          return { id: v.id, quantity: window.picked[s.id] };
        });
    })).then(function (items) {
      var n = items.reduce(function (a, i) { return a + i.quantity; }, 0);
      var unit = window.EL_PR_BUNDLE ? ' item' : ' bag';
      return window.ElevanaCart.add(items, n + unit + (n === 1 ? '' : 's') + ' from your bundle').then(function () {
        window.picked = {};
        if (typeof window.drawPicks === 'function') window.drawPicks();
      });
    }).catch(function (err) {
      if (window.ElevanaCart && err && err.message && !err.status) {
        window.ElevanaCart.open();
      }
    }).finally(function () { delete self.dataset.busy; if (typeof window.syncBundle === 'function') window.syncBundle(); });
  });
})();

/* "Build your bundle" safety net: entries are listed by name in each page script, so a product that gets
   drafted or archived would linger. Ask the store for each one and drop any it no longer serves (404). */
(function () {
  var list = window.STRAINS;
  if (!list || !list.forEach || !document.getElementById('picks')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  list.slice().forEach(function (s) {
    if (s.vid) return; /* built from live products already */
    var h = s.handle || String(s.name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    fetch(root + 'products/' + h + '.js').then(function (r) {
      if (r.status !== 404) return;
      var i = list.indexOf(s); if (i < 0) return;
      list.splice(i, 1);
      if (window.picked) delete window.picked[s.id];
      if (typeof window.drawPicks === 'function') window.drawPicks();
      if (typeof window.syncBundle === 'function') window.syncBundle();
    }).catch(function () {});
  });
  if (!list.length) { var b = document.getElementById('bundle'); if (b) b.hidden = true; }
})();
